import { WidgetUrlBehavior, WidgetUrlsConfig } from "@xapp/stentor-chat-widget";

export const defaultBehavior: WidgetUrlBehavior = {
    type: "newWindow"
};

export function resolveUrlPolicy(url: string, config: WidgetUrlsConfig): WidgetUrlBehavior {
    if (config.policies) {
        for (const policy of config.policies) {
            try {
                const re = new RegExp(policy.pattern, "gi");
                if (re.test(url)) {
                    return policy.behavior;
                }
            } catch {

            }
        }
    }
    return config.defaultBehavior || defaultBehavior;
}